var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.91 40.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set_of_64_UI_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96,9.91c-.68,0-1.32-.13-1.92-.39-.6-.26-1.13-.62-1.58-1.07s-.81-.98-1.07-1.58c-.26-.6-.39-1.25-.39-1.93s.13-1.32,.39-1.92c.26-.6,.62-1.13,1.07-1.57,.45-.45,.98-.8,1.58-1.06,.6-.26,1.25-.39,1.93-.39s1.32,.13,1.92,.39c.6,.26,1.13,.61,1.57,1.06,.45,.45,.8,.97,1.06,1.57,.26,.6,.39,1.25,.39,1.93s-.13,1.32-.39,1.92c-.26,.6-.61,1.13-1.06,1.58-.45,.45-.97,.81-1.57,1.07-.6,.26-1.25,.39-1.93,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96,24.98c-.68,0-1.32-.13-1.92-.39-.6-.26-1.13-.62-1.58-1.07s-.81-.98-1.07-1.58c-.26-.6-.39-1.25-.39-1.93s.13-1.32,.39-1.92c.26-.6,.62-1.13,1.07-1.57,.45-.45,.98-.8,1.58-1.06,.6-.26,1.25-.39,1.93-.39s1.32,.13,1.92,.39c.6,.26,1.13,.61,1.57,1.06,.45,.45,.8,.97,1.06,1.57,.26,.6,.39,1.25,.39,1.93s-.13,1.32-.39,1.92c-.26,.6-.61,1.13-1.06,1.58-.45,.45-.97,.81-1.57,1.07-.6,.26-1.25,.39-1.93,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96,40.06c-.68,0-1.32-.13-1.92-.39-.6-.26-1.13-.62-1.58-1.07s-.81-.98-1.07-1.58c-.26-.6-.39-1.25-.39-1.93s.13-1.32,.39-1.92c.26-.6,.62-1.13,1.07-1.57,.45-.45,.98-.8,1.58-1.06,.6-.26,1.25-.39,1.93-.39s1.32,.13,1.92,.39c.6,.26,1.13,.61,1.57,1.06,.45,.45,.8,.97,1.06,1.57,.26,.6,.39,1.25,.39,1.93s-.13,1.32-.39,1.92c-.26,.6-.61,1.13-1.06,1.58-.45,.45-.97,.81-1.57,1.07-.6,.26-1.25,.39-1.93,.39Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.2d6fb8cfc4bc04ab13c7a823664d415d.svg";
export { ForwardRef as ReactComponent };